import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_SERVICE,
  GENERATE_SERVICE_CODE,
  CHANGE_SERVICE_STATUS,
  CHANGE_SERVICE_STATUS_SUCCESS,
  CHANGE_SERVICE_STATUS_FAILURE,
  CREATE_SERVICE_REQUEST,
  DELETE_SERVICE,
} from "./actionTypes";
import * as types from './actionTypes';
import {
  fetchService,
  fetchServiceSuccess,
  fetchServiceFailure,
  generateServiceCode,
  generateServiceCodeSuccess,
  generateServiceCodeFailure,
  changeServiceStatus,
  changeServiceStatusSuccess,
  changeServiceStatusFailure,
  createServiceSuccess,
  createServiceFailure,
  deleteServiceSuccess,
  deleteServiceFailure,
} from "./actions";
import { get, post, update, del } from "../../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Service
function* fetchServiceSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_SERVICE, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve service!");
    }
    yield put(fetchServiceSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchServiceFailure(error.message));
  }
}

function* generateServiceCodeSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_GENERATE_SERVICE_CODE, formData);
    if (!response || response.status !== "Success") {
      throw new Error(response?.message || "Failed to retrieve service code!");
    }
    yield put(generateServiceCodeSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(generateServiceCodeFailure(error.message));
  }
}

function* changeServiceStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_CHANGE_SERVICE_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update head status!');
    }

    yield put({ type: types.CHANGE_SERVICE_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_SERVICE_STATUS_FAILURE, payload: error });
  }
}

// Create Service Saga
function* createServiceSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_SAVE_SERVICE, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Service saved successfully!",
      });
      yield put(createServiceSuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchService(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createServiceFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the deduction",
    });
    yield put(createServiceFailure(error.message));
  }
}

function* deleteServiceSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_DELETE_SERVICE, action.payload);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: response.message || "Service deleted successfully!",
      });
      yield put(deleteServiceSuccess(response));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to delete deduction!",
      });
      yield put(deleteServiceFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Delete Service Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while deleting the deduction",
    });
    yield put(deleteServiceFailure(error.message));
  }
}

// Watcher Saga
function* timesheetSetupServiceSaga() {
  yield takeEvery(FETCH_SERVICE, fetchServiceSaga);  
  yield takeEvery(GENERATE_SERVICE_CODE, generateServiceCodeSaga); 
  yield takeEvery(CHANGE_SERVICE_STATUS, changeServiceStatusSaga);
  yield takeEvery(CREATE_SERVICE_REQUEST, createServiceSaga);
  yield takeEvery(DELETE_SERVICE, deleteServiceSaga);
}

export default timesheetSetupServiceSaga;
